/**
 * Enum representing a user type (private or company).
 */
export enum THGUserType {
    PRIVATE = 'private',
    COMPANY = 'company',
}
